// extracted by mini-css-extract-plugin
export default {"scrolleffect":"RetailWebsiteLink_scrolleffect__IjRtZ","noscrolleffect":"RetailWebsiteLink_noscrolleffect__EGVQq"};